import { render } from "./CreateAccountCompany.vue?vue&type=template&id=828217c8&scoped=true"
import script from "./CreateAccountCompany.vue?vue&type=script&lang=js"
export * from "./CreateAccountCompany.vue?vue&type=script&lang=js"

import "@/assets/styles/login.css?vue&type=style&index=0&id=828217c8&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-828217c8"]])

export default __exports__